import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, watch } from "vue";
import { useModelValue } from "../../../../composables/useSyncProp";
import { QButton } from "../../../shared";
import { Category } from "../types/Category";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditCategoryModal',
  props: {
	value: {
		type: Boolean as PropType<boolean>,
		required: true,
	},
	category: {
		type: Object as PropType<Category>,
		required: true,
	},
	disabled: {
		type: Boolean as PropType<boolean>,
		required: true,
	},
	title: {
		type: String as PropType<string>,
		default: 'Update Category'
	},
	possibleParentCategories: {
		type: Array as PropType<Category[]>,
		required: true,
	},
},
  emits: ["update:category", "input"],
  setup(__props, { emit }: { emit: ({
	(e: "update:category", category: Category): void;
	(e: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const changedCategory = ref<Category>(props.category);

watch(
	() => props.category,
	() => {
		changedCategory.value = props.category;
	}
);



const form = ref();
const saveCategory = () => {
	if (form.value.validate()) {
		emit("update:category", changedCategory.value);
	}
};

const doShow = useModelValue(props, emit);

const isValid = ref(true);

return { __sfc: true,props, changedCategory, emit, form, saveCategory, doShow, isValid, QButton }
}

})